import {store} from "./store";

export const useLoginOrRegistrationModalStore = store;
